module.exports = __webpack_public_path__ + "assets/img/Singapore Polytechnic.2a275d97.jpg";